import {Component, Input, OnInit} from '@angular/core';
import {FormGroup} from '@angular/forms';

@Component({
  selector: 'app-user-type-radio',
  template: `
    <div class="radio-container" [formGroup]="parent">
      <mat-radio-group [formControlName]="controlName">
        <mat-radio-button value="company" color="primary">Company</mat-radio-button>
        <mat-radio-button value="private" color="primary">Private</mat-radio-button>
      </mat-radio-group>
    </div>
  `,
  styleUrls: ['./user-type.component.scss']
})
export class UserTypeComponent implements OnInit {
  @Input() parent: FormGroup;
  @Input() controlName: string;
  constructor() { }

  ngOnInit() {
    this.parent.get(this.controlName).valueChanges
      .subscribe(data => {
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/components/atoms/user-type/user-type.component.ts